import {FontVariant} from '../../design-tokens/generated/constants';

export const colorSchemeValues = ['dark', 'light'] as const;
export type ColorScheme = typeof colorSchemeValues[number];

export const brandableButtonVariantValues = ['primary', 'secondary', 'tertiary'] as const;
export const nonBrandableButtonVariantValues = [
    'neutral',
    'translucent',
    'transparent',
    'transparentAlternative',
    'text',
    'danger',
    'dangerBordered',
    'success',
] as const;

export const buttonVariantsValues = [...brandableButtonVariantValues, ...nonBrandableButtonVariantValues] as const;
export type ButtonVariant = typeof buttonVariantsValues[number];

export const inputVariantsValues = ['standard', 'transparent'] as const;
export type InputVariant = typeof inputVariantsValues[number];

export const labelModifierValues = ['hidden', 'inline'] as const;
export type LabelModifier = typeof labelModifierValues[number];

export const shadowModifierValues = ['light', 'dark'] as const;
export type ShadowModifier = typeof shadowModifierValues[number];

export const headingFontVariantsValues = [
    FontVariant.H1,
    FontVariant.H2,
    FontVariant.H3,
    FontVariant.H4,
    FontVariant.H5,
    FontVariant.H6,
] as const;
export type HeadingFontVariant = typeof headingFontVariantsValues[number];

export const statIndicatorVariantValues = [
    'success',
    'busy',
    'danger',
    'warning'
] as const;
export type StatIndicatorVariant = typeof statIndicatorVariantValues[number];

export const textVariantsValues = [
    'standard',
    'tinted',
    'subtle',
    'disabled',
    'danger',
    'success',
    'inherit',
    'link',
    'hidden',
    'warning',
] as const;
export type TextVariant = typeof textVariantsValues[number];

export const videoWrapperVariantsValues = [
    'none',
    'primary',
    'secondary',
    'black',
    'light'
] as const;
export type VideoWrapperVariant = typeof videoWrapperVariantsValues[number];

export const fullSizeWindowBackgroundVariantsValues = [
    'none',
    'dark',
    'light',
    'white'
] as const;
export type FullSizeWindowBackgroundVariant = typeof fullSizeWindowBackgroundVariantsValues[number];

export const multistepIndicatorValues = ['ordered-list', 'line'] as const;
export type MultistepIndicatorVariant = typeof multistepIndicatorValues[number];

export const badgeCounterVariantValues = ['info', 'notification'] as const;
export type BadgeCounterVariant = typeof badgeCounterVariantValues[number];